import React from "react";
import { flagsAndExperimentNames, useOnLoadFlagOrExperiment } from "../hoc/with-flags-and-experiments";
import GridFilterSizeSelector from "./grid-filter-modal-size-selector";
import GridFilterModalZipSelector from "./grid-filter-modal-zip-selector";
import { useAppSelector } from "../../../../../util/store-types";
import GridFilterModalAvailabilitySection from "./grid-filter-modal-availability-section";

export type CoreFiltersProps = {
  isSwapsGrid?: boolean;
  onSubmitFilters: () => void;
};

const CoreFilters = ({ isSwapsGrid, onSubmitFilters }: CoreFiltersProps) => {
  const [coreFilterFlag] = useOnLoadFlagOrExperiment(flagsAndExperimentNames.RESERVE_FILTER);
  const isRentable = useAppSelector(state => state.gridView?.isRentable);
  const showSizeSectionOnly = !isRentable || isSwapsGrid;

  if (!coreFilterFlag) {
    return null;
  }

  return (
    <div className="bg-offWhite px-4 py-4 font-normal flex flex-col gap-4">
      {!showSizeSectionOnly && <GridFilterModalAvailabilitySection onSubmitFilters={onSubmitFilters} />}
      {!showSizeSectionOnly && <GridFilterModalZipSelector onSubmitFilters={onSubmitFilters} />}
      <GridFilterSizeSelector onSubmitFilters={onSubmitFilters} />
    </div>
  );
};

export default CoreFilters;
